import { Apple } from "./Apple";
import CircleLoader from "./CircleLoader";
import { EmptyDraftSvg } from "./EmptyDraftSvg";
import { Google } from "./Google";
import HexagonIcon from "./HexagonIcon";

export const Icons = {
  Google,
  Apple,
  HexagonIcon,
  CircleLoader,
  EmptyDraftSvg,
};
export type { IconProps } from "./Icons";
